<template>
  <div class="about-container">
    <div class="about-container-left">
      <pageNav :active="2" />
    </div>
    <div class="about-container-right">
      <div class="about-container-right-content" style="width: 100%;">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item :label="$i18n.$t('问题点')" prop="origin_text">
            <el-select v-model="form.origin_text" :placeholder="$i18n.$t('请选择')" style="width: 100%;">
              <el-option :label="$i18n.$t('首页')" :value="$i18n.$t('首页')"></el-option>
              <el-option :label="$i18n.$t('高级检索')" :value="$i18n.$t('高级检索')"></el-option>
              <el-option :label="$i18n.$t('社会关系')" :value="$i18n.$t('社会关系')"></el-option>
              <el-option :label="$i18n.$t('师承关系')" :value="$i18n.$t('师承关系')"></el-option>
              <el-option :label="$i18n.$t('人物足迹')" :value="$i18n.$t('人物足迹')"></el-option>
              <el-option :label="$i18n.$t('地点查询')" :value="$i18n.$t('地点查询')"></el-option>
              <el-option :label="$i18n.$t('传记记载')" :value="$i18n.$t('传记记载')"></el-option>
              <el-option :label="$i18n.$t('关系发现')" :value="$i18n.$t('关系发现')"></el-option>
              <el-option :label="$i18n.$t('时间图谱')" :value="$i18n.$t('时间图谱')"></el-option>
              <el-option :label="$i18n.$t('关于')" :value="$i18n.$t('关于')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$i18n.$t('问题类型')" prop="question_type">
            <el-select v-model="form.question_type" :placeholder="$i18n.$t('请选择')" style="width: 100%;">
              <el-option v-for="(row, index) in feedback_types" :key="index" :label="$i18n.$t(row.description)" :value="row.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$i18n.$t('您的建议')" prop="suggestion">
            <el-input v-model="form.suggestion" type="textarea" :maxlength="500" show-word-limit :rows="16" resize="none" :placeholder="$i18n.$t('我们想知道您对结果不满意的原因')"></el-input>
          </el-form-item>
          <el-form-item :label="$i18n.$t('附件')">
            <ul class="el-upload-list el-upload-list--picture-card">
              <li v-for="(file, index) in form.attachment" :key="index" class="el-upload-list__item is-ready">
                <img class="el-upload-list__item-thumbnail" :src="file" alt="">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-upload-list__item-delete"><i class="el-icon-download"></i></span>
                  <span class="el-upload-list__item-delete"><i class="el-icon-delete"></i></span>
                </span>
              </li>
              <li class="el-upload-list__item is-ready">
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :showFileList="false"
                  accept="image/*"
                  :http-request="uploadAction">
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </li>
            </ul>
          </el-form-item>
          <el-form-item>
            <el-button style="display: block;width: 200px;margin: 0 auto;margin-top: 30px;" type="primary" @click="submitForm">{{ $i18n.$t('立即提交') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
import {
  getOssToken,
  feedbackMeta,
  submit
} from '@/api/pub'
import axios from 'axios'
import { Message } from 'element-ui'
export default {
  name: 'AboutFeedback',
  meta: {
    title: i18n.$t('关于')
  },
  data () {
    return {
      form: {
        origin_text: '',
        feedback_type: 'knowledge_graph',
        source: 'by_knowledge_graph',
        question_type: '',
        suggestion: '',
        attachment: []
      },
      feedback_types: [],
      rules: {
        origin_text: [
          { required: true, message: this.$i18n.$t('请选择问题点'), trigger: 'change' }
        ],
        question_type: [
          { required: true, message: this.$i18n.$t('请选择问题类型'), trigger: 'change' }
        ],
        suggestion: [
          { required: true, message: this.$i18n.$t('请输入您的建议'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getMeta()
  },
  methods: {
    getMeta () {
      feedbackMeta().then(res => {
        if (res.result) {
          const row = (res.result.feedback_types || []).find(row => row.value === 'knowledge_graph')
          if (row) {
            this.feedback_types = row.question_types
          }
        }
      })
    },
    async uploadAction (params) {
      try {
        const { file } = params
        const names = file.name.split('.')
        const tokenRes = await getOssToken()
        if (!tokenRes.result) {
          return Message({
            message: tokenRes.detail,
            type: 'error'
          })
        }
        const result = JSON.parse(tokenRes.result)
        const { host, signature, policy, accessid, dir } = result
        const form = new FormData()
        const key = `${dir}${parseInt(new Date().getTime() * Math.random())}.${names[names.length - 1]}`
        form.append('key', key)
        form.append('policy', policy)
        form.append('OSSAccessKeyId', accessid)
        form.append('signature', signature)
        form.append('success_action_status', '200')
        form.append('file', file)
        await axios({
          method: 'post',
          url: host,
          data: form,
          headers: { 'Content-Type': 'multipart/form-data', accept: '*/*' },
          withCredentials: false
        })
        this.form.attachment.push(`${host}/${key}`)
      } catch (error) {
        Message({
          message: error.message || '上传失败',
          type: 'error'
        })
      }
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          submit({
            ...this.form,
            attachment: this.form.attachment.join(',')
          }).then(res => {
            if (res.code === 0) {
              this.form.attachment = []
              this.$refs.form.resetFields()
              Message({
                message: '提交成功',
                type: 'success'
              })
            } else {
              Message({
                message: '提交失败',
                type: 'error'
              })
            }
          }).catch(error => {
            Message({
              message: error.message || '提交失败',
              type: 'error'
            })
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-upload--picture-card {
    border: none;
  }
  .el-form-item__label {
    font-size: 18px;
  }
  .el-form-item__content * {
    font-size: 18px;
    font-family: sans-serif;
  }
  .el-textarea .el-input__count {
    font-size: 18px;
  }
}
</style>
